import { format } from 'date-fns'
import * as React from 'react';

import Popup from '../modals/Popup'

const PopupTerms = (props) => {
  const { onClose, onChange, isSelected, initialSelected } = props;

  const input = initialSelected ? (
    /* <label className="popup__label">Accepted on {format(initialSelected,'MM/DD/YYYY')}</label> */
    null
  ) : (
    <label htmlFor="terms" className="popup__label">
      <input type="checkbox" name="terms" id="terms" className='popup__checkbox' checked={isSelected} onChange={onChange} />
      <span className="popup__checkbox--status"/>
      Accept terms of service?
    </label>
  );

  return (
    <Popup onClose={onClose}>
      <div className="popup__content">
        <h2 className="popup__title">Relay Payments Terms of Service</h2>
        <p className="popup__text">
         By continuing, I accept Relay's <a href="https://www.relaypayments.com/legal" target="_blank">Terms of Service</a>.
        </p>
      </div>
      <div className='popup__footer'>
        {input}
        <button className="btn btn--prim btn--md btn--white" onClick={onClose}>CONTINUE</button>
      </div>
    </Popup>
  );
};

export default PopupTerms;
